/*
 * @Author: jasonzxzhou
 * @Date: 2023-4-27 14:31:25
 * @Description: 此文件仅在renderer进程加载,包含需语言翻译的设置
 */

import { i18n_t } from '@/locales/i18n';

export const userRole: {
  [key: string]: string;
} = {
  user: i18n_t('普通用户'),
  admin: i18n_t('系统管理员'),
  superAdmin: i18n_t('超级管理员'),
  teamAdmin: i18n_t('团队管理员'),
};

export const SEARCH_SCOPE_MAP = {
  title: i18n_t('搜索范围'),
  all: i18n_t('当前空间'),
  current: i18n_t('当前文件夹'),
};

export const SEARCH_TYPE_MAP = {
  title: i18n_t('文件类型'),
  all: i18n_t('全部'),
  dir: i18n_t('文件夹'),
  file: i18n_t('文件'),
  doc: i18n_t('Word文档'),
  xls: i18n_t('Excel文档'),
  excel: i18n_t('Excel文档'),
  ppt: i18n_t('PPT文档'),
  pdf: i18n_t('PDF文档'),
  txt: i18n_t('纯文本类型'),
  image: i18n_t('图片'),
  video: i18n_t('视频'),
  audio: i18n_t('音频'),
  other: i18n_t('其他'),
  word: i18n_t('Word文档'),
  portable: i18n_t('PDF文档'),
  powerpoint: i18n_t('PPT文档'),
  text: i18n_t('纯文本类型'),
  archive: i18n_t('压缩文件'),
};

export const BUSINESS_OPTIONS = [
  {
    label: i18n_t('教育行业'),
    value: 'education',
    description: i18n_t('知识沉淀管理，分享更高效'),
    icon: 'education-img',
    isCreated: false,
  },
  {
    label: i18n_t('金融行业'),
    value: 'finance',
    description: i18n_t('掌控信息安全的企业生命线'),
    icon: 'finance-img',
    isCreated: false,
  },
  {
    label: i18n_t('零售行业'),
    value: 'retail',
    description: i18n_t('跨地极速传输，上下游无间协作'),
    icon: 'retail-img',
    isCreated: false,
  },
  {
    label: i18n_t('医疗行业'),
    value: 'medical',
    description: i18n_t('统一归档实现数据信息化管理'),
    icon: 'medical-img',
    isCreated: false,
  },
];

export const SCALE_OPTIONS = [
  {
    label: i18n_t('1-5人'),
    value: i18n_t('1-5人'),
  },
  {
    label: i18n_t('6-10人'),
    value: i18n_t('6-10人'),
  },
  {
    label: i18n_t('11-30人'),
    value: i18n_t('11-30人'),
  },
  {
    label: i18n_t('31-50人'),
    value: i18n_t('31-50人'),
  },
  {
    label: i18n_t('50-100人'),
    value: i18n_t('50-100人'),
  },
  {
    label: i18n_t('101-500人'),
    value: i18n_t('101-500人'),
  },
  {
    label: i18n_t('500人以上'),
    value: i18n_t('500人以上'),
  },
];

export const POSITION_OPTIONS = [
  {
    label: i18n_t('创始人'),
    value: i18n_t('创始人'),
  },
  {
    label: i18n_t('商务负责人'),
    value: i18n_t('商务负责人'),
  },
  {
    label: i18n_t('研发负责人'),
    value: i18n_t('研发负责人'),
  },
  {
    label: i18n_t('采购负责人'),
    value: i18n_t('采购负责人'),
  },
  {
    label: i18n_t('部门管理人'),
    value: i18n_t('部门管理人'),
  },
  {
    label: i18n_t('信息化负责人 '),
    value: i18n_t('信息化负责人 '),
  },
  {
    label: i18n_t('员工'),
    value: i18n_t('员工'),
  },
];

/**
 * 用户操作的map字典
 */
export const operatorMap = new Map([
  ['download', i18n_t('下载')],
  ['preview', i18n_t('预览')],
  ['delete', i18n_t('删除')],
  ['move', i18n_t('移动')],
  ['rename', i18n_t('重命名')],
  ['copy', i18n_t('复制')],
  ['create', i18n_t('新增')],
  ['update', i18n_t('更新')],
  ['restore', i18n_t('还原')],
  ['modify', i18n_t('编辑')],
]);

/** 命名规则存量数据兼容处理 */
/* i18n-ignore*/
export const RULE_LIST_VALUE_MAP: { [key: string]: string } = {
  姓名: 'name',
  手机号: 'phoneNumber',
  学号: 'studentId',
  工号: 'workNumber',
  邮箱: 'email',
  身份证号码: 'idNumber',
};
/* i18n-ignore*/
export const RULE_LIST_MAP: { [key: string]: string } = {
  name: i18n_t('姓名'),
  phoneNumber: i18n_t('手机号'),
  studentId: i18n_t('学号'),
  workNumber: i18n_t('工号'),
  email: i18n_t('邮箱'),
  idNumber: i18n_t('身份证号码'),
};

export const industryCardList = [
  {
    id: 7,
    title: i18n_t('金融行业专属攻略'),
    text: i18n_t('提供文件安全管理、员工安全管控、高效办公协作的解决方案'),
    icon: 'industry-1',
  },
  {
    id: 8,
    title: i18n_t('医疗行业专属攻略'),
    text: i18n_t('提供存储资料影像、便捷分享协作、文件审批的解决方案'),
    icon: 'industry-2',
  },
  {
    id: 9,
    title: i18n_t('零售行业专属攻略'),
    text: i18n_t('提供生产资料流转、资料协作分享、员工安全管控的解决方案'),
    icon: 'industry-3',
  },
  {
    id: 10,
    title: i18n_t('教育行业专属攻略'),
    text: i18n_t('提供作业收集，教学资料库管理，内容安全管理服务'),
    icon: 'industry-4',
  },
  {
    id: 11,
    title: i18n_t('网盘使用攻略'),
    text: i18n_t('提供一站式文件安全管理、高效办公协作、在线签合同的解决方案'),
    icon: 'industry-5',
  },
];

export const industryCardListIds = industryCardList.map(item => item.id);

export const industryTypeMap = new Map([
  [7, 'finance'],
  [8, 'medical'],
  [9, 'retail'],
  [10, 'education'],
  [11, 'general'],
]);

/* i18n-ignore*/
export const BusinessTypeMap = new Map([
  ['金融行业', 7],
  ['finance', 7],
  ['医疗行业', 8],
  ['medical', 8],
  ['零售行业', 9],
  ['retail', 9],
  ['教育行业', 10],
  ['education', 10],
]);
